export default __webpack_public_path__ + "static/media/capitaGreen.jpg?.cd6053c9";